import { render } from "./KetersediaanKelasPage.vue?vue&type=template&id=342e8bbe&scoped=true"
import script from "./KetersediaanKelasPage.vue?vue&type=script&lang=js"
export * from "./KetersediaanKelasPage.vue?vue&type=script&lang=js"

import "./KetersediaanKelasPage.vue?vue&type=style&index=0&id=342e8bbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342e8bbe"]])

export default __exports__